<template>
  <div>
    <m-reward-summary />
    <m-reward-check-out />
    <m-content title="Reward">
      <div slot="title-right">
        <b-link @click="$root.$emit('bv::show::modal', 'rewardSummaryModal')">
          Available Point: <span class="available-point">{{availablePoint | numberFormat('', 0)}}</span>
        </b-link>
      </div>
      <div class="box">
        <div class="the-slide">
          <m-reward-slide />
        </div>
        <div class="the-content">
          <m-reward-item />
        </div>
      </div>
    </m-content>
  </div>
</template>

<script>
  import MContent from '@/components/layouts/MContent'
  import MRewardSlide from '@/components/reward/MRewardSlide'
  import MRewardItem from '@/components/reward/MRewardItem'
  import MRewardSummary from '@/components/reward/MRewardSummary'
  import MRewardCheckOut from '@/components/reward/MRewardCheckOut'

  export default {
    components: {
      MContent,
      MRewardSlide,
      MRewardSummary,
      MRewardItem,
      MRewardCheckOut
    },
    data () {
      return {
      }
    },
    created () {
      this.init()
    },
    computed: {
      availablePoint () {
        return this.$store.state.reward.point.AvailablePoints
      }
    },
    methods: {
      init () {
        this.$store.dispatch('reward/init')
      }
    }
  }
</script>

<style scoped lang="scss">
  .box {
    display: flex;
    flex-wrap: nowrap;
  }
  .the-slide {
    width: 20%;
    max-width: 400px;
    margin-right: 24px;
    background: $color-background;

    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: .25rem;
    padding: 16px;
  }
  .the-content {
    width: 100%;
    flex-grow: 0;
  }

  @media(max-width: 768px) {
    .the-slide {
     min-width: 100px;
    }
  }
  .available-point {
    font-size: 18px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Reward.vue